const nameData = "themes"; // Define la entidad dinámica
const nameDataSingular = "theme"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData, searchTerm, numPagina, filas) => {
  try {
    const data = await getEntityPanelData(searchTerm, numPagina, filas);
    console.log("data",data)
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      const totalDataItems = data.pagination.totalItems || 0;
      return {
        dataEntity: data[nameData] || [], // Usa nameData dinámicamente
        totalItems: data.pagination.totalItems || 0,
        totalPage,
        totalDataItems
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
